module.exports = __webpack_public_path__ + "img/stock4.d5af4048.png";